import { Progress, Text } from "@mantine/core";
import { observer } from "mobx-react";
import styles from "./styles/EpisodeProgress.module.css";
import { useStores } from "@/hooks/useStores";

interface EpisodeProgressProps {
    episodeId: number;
    /** Say how far the listener is in words ("Du har lyssnat 23 av 58 min") */
    detailed?: boolean;
    /** Show "Spelad" for finished episodes; off where the list shows it in its own meta line */
    showPlayed?: boolean;
}

const minutes = (seconds: number) => Math.max(1, Math.round(seconds / 60));

/** How far the listener is in an episode: a thin bar while unfinished, "Spelad" when done. */
export const EpisodeProgress = observer(({ episodeId, detailed = false, showPlayed = true }: EpisodeProgressProps) => {
    const { listeningStore } = useStores();
    const entry = listeningStore.entry(episodeId);
    const progress = listeningStore.progress(episodeId);

    if (entry?.played) {
        return showPlayed ? (
            <Text c="dimmed" size="sm">
                Spelad
            </Text>
        ) : null;
    }

    if (!entry || progress <= 0) {
        return null;
    }

    return (
        <div className={styles.wrap}>
            <Progress
                aria-label={`Lyssnat ${Math.round(progress * 100)} procent`}
                className={styles.bar}
                size={4}
                value={progress * 100}
            />
            {detailed && (
                <Text c="dimmed" size="sm">
                    Du har lyssnat {minutes(entry.position)} av {minutes(entry.duration)} min
                </Text>
            )}
        </div>
    );
});
